import React from "react";
import Experience from "../Experience/Experience";
import Education from "../Education/Education";
import SectionHeader from "../Common/Section-Header/SectionHeader";
import Fade from "react-reveal/Fade";
import "./Resume.scss";

const Resume = () => {
  return (
    <section className="section-separator" id="resume">
      <div className="container mb-5">
        <Fade bottom>
          <SectionHeader subtitle="Curriculum Vitae" title="My Experience" />
        </Fade>

        <Fade bottom>
          <div className="row mt-5" id="nav-menu">
            <div className="col-8 offset-2">
              <div className="nav-list">
                <ul className="nav nav-pills mb-3 nav-justified">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-bs-toggle="pill"
                      data-bs-target="#experience"
                      href="#experience"
                    >
                      Experience
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="pill"
                      data-bs-target="#education"
                      href="#education"
                    >
                      Education
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Fade>

        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade show active" id="experience">
            <Experience />
          </div>
          <div className="tab-pane fade" id="education">
            <Education />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
